import classNames from 'classnames';
import { format } from 'date-fns';
import { Translation } from '~/components/I18n';
import { Mission, useRemainingTime } from '~/components/Mission/Mission.hooks';
import styles from './MissionDescriptionList.module.scss';

const DATE_FORMAT = 'PP p';

export type MissionDescriptionListProps = {
  className?: string;
} & Mission;

export const MissionDescriptionList = ({
  className,
  status,
  startAt,
  endAt,
  missionCompleted,
}: MissionDescriptionListProps) => {
  const remainingTime = useRemainingTime(endAt);

  return (
    <dl className={classNames(styles.root, className)}>
      {(() => {
        switch (status) {
          case 'ended':
            return (
              <div>
                <dt>
                  <Translation name="citizen_mission_period" />
                </dt>
                <dd>
                  {format(startAt, DATE_FORMAT)} ~ {format(endAt, DATE_FORMAT)} (
                  <Translation name="citizen_mission_period_closed" />)
                </dd>
              </div>
            );
          case 'in_progress':
            return missionCompleted ? (
              <>
                <div>
                  <dt>
                    <Translation name="citizen_mission_remain" />
                  </dt>
                  <dd>{remainingTime}</dd>
                </div>
                <div>
                  <dt>
                    <Translation name="citizen_mission_condition" />
                  </dt>
                  <dd>
                    <Translation name="citizen_mission_condition_desc" />
                  </dd>
                </div>
              </>
            ) : (
              <div>
                <dt>
                  <Translation name="citizen_mission_period" />
                </dt>
                <dd>
                  {format(startAt, DATE_FORMAT)} ~ {format(endAt, DATE_FORMAT)}
                </dd>
              </div>
            );
          case 'upcoming':
            return null;
        }
      })()}
    </dl>
  );
};
